import licitacao from './LicitacaoApiClient'
import produto from './ProdutoApiClient'
import validarDocumentoApi from './ValidacaoDocumentoApiClient'
import efornecedor from './EfornecedorApiClient'
import credenciamento from './CredenciamentoApiClient'

export default {
    licitacao,
    produto,
    validarDocumentoApi,
    efornecedor,
    credenciamento,
}
